<template>
    <v-container fluid class="mt-0 pt-0 fill-height appbackground d-flex align-center justify-center">
        <v-row class="fill-height px-2 d-flex align-center justify-center" no-gutters> 
            <v-col cols="12" xs="12" sm="12" md="12" lg="8" class="">

                <v-progress-linear v-if="$vuetify.breakpoint.smAndDown" class="mt-5 align-center v-progress-linear" background-color="grey" color="darkgrey" height="5" :value="quizProgressPercent"></v-progress-linear>
                <v-progress-linear v-if="$vuetify.breakpoint.mdAndUp" class="mt-5 align-center" background-color="grey" color="darkgrey" height="5" :value="quizProgressPercent"></v-progress-linear>

                <div v-if="$vuetify.breakpoint.smAndDown" class="d-flex align-end mt-3">
                    <appbutton class="pr-2" v-if="activeQuestionIndex != 0" @click.native="previousQuestion" :label="$t(`buttons.back`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" />
                    <appbutton class="pl-2" v-if="showEndPage === true " @click.native="restartQuiz()" :label="$t(`buttons.restart`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" /> 
                    <v-spacer></v-spacer>
                    <appbutton v-if="correctAnswer && showEndPage != true && activeQuestionIndex < quizQuestions.length - 1" @click.native="nextQuestion" :label="$t(`buttons.next`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly"/>
                    <appbutton v-if="correctAnswer && showEndPage != true && activeQuestionIndex >= quizQuestions.length - 1" @click.native="showEndPage = true" label="Finish" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly"/>
                    <!-- Complete Induction Button  -->
                    <appbutton v-else-if="showEndPage===true && (quizScore / totalQuizPoints) * 100 >= 80" @click.native="submitConfirmation" :label="$t(`buttons.submit`)" type="blue" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" />
                </div>

                <v-carousel :min-height="carouselHeight" :style="'height:' + carouselHeight" :show-arrows="false" hide-delimiters>
                    
                    <v-row >
                        <v-carousel-item style="width: 100% !important; " :key="i" reverse-transition="fade-transition" transition="fade-transition" eager>

                            <v-row :style="'width: 100% !important; height:' + carouselHeight"  fill-width class="ma-0 pa-0 d-flex justify-start ">
                                <v-col v-if="!showEndPage" cols="12" class="">
                                    <div class="text-h6 text-md-h5 text-lg-h5 font-weight-thin d-flex align-center justify-start primary--text">
                                        Question {{ activeQuestionIndex + 1 }} of {{ quizQuestions.length }}
                                    </div>
                                    
                                    <div class="grey--text text-body-1 text-md-body-2 text-lg-h6 text--darken-2 mt-2" v-html="activeQuestion.questionTitle">
                                    </div>
                                    <div class="mt-6">
                                        <v-btn
                                            v-for="(answer, index) in activeQuestion.answers"
                                            :key="index"
                                            class="question-card elevation-0 mb-4 rounded-lg font-weight-bold px-10 grey custom-btn"
                                            @click="checkAnswer(answer.correct, index, answer.points)"
                                            block
                                            x-large
                                            style="white-space: normal;"
                                        >
                                            <span class="text-wrap" :style="$vuetify.breakpoint.smAndDown ? 'max-width: 300px !important;' : 'max-width: 800px !important;'">{{ answer.text }}</span>
                                        </v-btn>
                                    </div>
                                </v-col>
                                <v-col cols="12" v-if="showEndPage" style="height: 100% !important">
                                    <v-card class="d-flex flex-column align-center appbackground justify-center elevation-0" :style="showEndPage != true && 'height: 100% !important'">
                                        <div v-if="(quizScore / totalQuizPoints) * 100 < 80" class="text-h4 primary--text pt-6">You require a minimum of 8 points to complete your Induction, please try again</div>
                                        
                                        <div v-if="(quizScore / totalQuizPoints) * 100 >= 80 && (quizScore / totalQuizPoints) * 100 <= 100" class="text-h4 primary--text pt-6">
                                        Congratulations, you have completed your Induction</div>
                                        <v-card-text class="text-h5 grey--text text-center pb-2"
                                            >You scored <b>{{ quizScore }}</b> out of a possible <b>{{ totalQuizPoints }}</b> points.</v-card-text
                                        >
                                    </v-card>
                                </v-col>
                            </v-row>
                        
                            <!-- i removed this because it seems to be causing the issue and we want the quiz to load on mobile -> curtis -->
                            <!-- <v-row v-if="$vuetify.breakpoint.smAndDown" class="ma-0 pa-0 d-flex justify-start">
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" class="ma-0 pa-0">
                                    <div class="text-h6 text-md-h5 text-lg-h5 font-weight-thin d-flex mt-3 align-center justify-start primary--text">
                                        {{ item.quizName }}
                                    </div>
                                    
                                    <div class="grey--text text-body-2 text-md-body-2 text-lg-body-1 text--darken-2 mt-1" v-html="item.quizDesc"></div>
                                    <v-checkbox v-if="i===quizQuestions.length -1 && inductionStatus !== 'valid' " color="primary"  v-model="checkbox">
                                       <span slot="label" class="black--text text-body-2"> I confirm that I have read and understood the information from the Induction questions</span>
                                    </v-checkbox>
                                    <div class="d-flex align-end mt-5">
                                        <appbutton class="pr-2" v-if="showEndPage != true && activeQuestionIndex !=0" @click.native="previousQuestion" :label="$t(`buttons.back`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" />
                                        <appbutton v-else-if="showEndPage === true && activeQuestionIndex !=0" @click.native="previousQuestion" :label="$t(`buttons.back`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" /> 
                                        <appbutton class="pl-2" v-if="showEndPage === true " @click.native="restartQuiz()" :label="$t(`buttons.restart`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" /> 
                                        <v-spacer></v-spacer>
                                        <appbutton v-if="showEndPage != true" @click.native="nextQuestion" :disabled="!correctAnswer" :label="$t(`buttons.next`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" />
                                    </div>
                                </v-col>
                            </v-row> -->

                        </v-carousel-item>
                    </v-row>
                </v-carousel>
                
                <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex align-end mt-5 px-2">
                    <appbutton class="pr-2" v-if="activeQuestionIndex != 0" @click.native="previousQuestion" :label="$t(`buttons.back`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" />
                    <appbutton class="pl-2" v-if="showEndPage === true " @click.native="restartQuiz()" :label="$t(`buttons.restart`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" /> 
                    <v-spacer></v-spacer>
                    <appbutton v-if="correctAnswer && showEndPage != true && activeQuestionIndex < quizQuestions.length - 1" @click.native="nextQuestion" :label="$t(`buttons.next`)" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly"/>
                    <appbutton v-if="correctAnswer && showEndPage != true && activeQuestionIndex >= quizQuestions.length - 1" @click.native="showEndPage = true" label="Finish" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly"/>
                    <!-- Complete Induction Button  -->
                    <appbutton v-else-if="showEndPage===true && (quizScore / totalQuizPoints) * 100 >= 80" @click.native="submitConfirmation" :label="$t(`buttons.submit`)" type="blue" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" />
                    <!-- <appbutton v-else-if="checkbox===true" @click.native="goToQuiz" label="Proceed to Quiz" type="blue" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" /> -->
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
    export default {
        // * DATA
        data: () => ({
            collection: 'induction',
            collectionTitle: 'Induction',
            collectionItem: 'induction',
            collectionItemTitle: 'Induction',  
            checkbox: false,
            langPath: 'induction',
            theNameOfSites: "",
            questions: [],
            initialSlidesArray : [],
            showEndPage: false,
            multipleSlideArray:[],
            inductionDate: [],
            sites: [],
            i: 0,
            quizNumber: 0,
            siteSlideRules: [(v) => !!v || "The Site name is required"],
			inductionDone: false,
			inductionStatus: "",
			inductionDue: null,
			inductionRenewal: null,
            correctAnswer: false,
            answerAttempt: 0,
            quizScore: 0,
            totalQuizPoints: 10,
            activeQuestionIndex: 0,
            quizProgressPercent: 0,
            quizQuestions: [],
            selectedSite: '',
        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
				GET_currentUser: "GET_currentUser",
			}),
            // SORT SLIDE BY SLIDE ORDER
            sortSlideBySlideOrder() {
                var t = this;
                // for (var i = 0; i < t.questions.length; i++) {
                //     // if (t.questions[i].slideStatus ==="LIVE") {
                //         //  for (var j = 0; j < t.questions[i].userType.length; j++) {
                //         //     if ( t.GET_currentUser.userType == t.questions[i].userType[j] && !t.multipleSlideArray.includes(t.questions[i])){
                //                 t.multipleSlideArray.push(t.questions[i]);
                //                 // break;
                //         //     }
                //         // }
                //     // }
                // }
                // t.multipleSlideArray.sort(function(a, b) {
                //     return a.slideOrder - b.slideOrder;
                // });

                // if (t.inductionStatus === 'valid') {
                //     t.multipleSlideArray.splice(-1, 1)
                // }

                return t.multipleSlideArray;

            },
            activeQuestion() {
                let t = this
                // console.log('activeQuestionIndex', t.activeQuestionIndex)
                return t.quizQuestions[t.activeQuestionIndex]
            },
            carouselHeight() {
                // return '100%';
                switch(this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return '850px';
                        break;
                    case 'sm':
                        return '800px';
                        break;
                    case 'md':
                        return '310px';
                        break;
                    case 'lg':
                        return '380px';
                        break;
                    case 'xl':
                        return '480px';
                        break;
                    default:
                        return '100px'
                        break;
                }
            },
        },
        // * WATCH
        watch: {
            quizNumber() {
                // console.log('changing quiz number')
                document.querySelectorAll('.question-card').forEach((element) => {
                    element.classList.remove('right-answer')
                    element.classList.remove('wrong-answer')
                    element.classList.add('grey')
                })  
            },
            selectedSite() {
                this.readQuizFromDB();
            }
        },
        // * METHODS
        methods: {
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                t.MIX_breadcrumbs(breadcrumbs);
            },

			currentUsersInduction() {
				var t = this;

                var inductions = t.GET_currentUser.inductions || [];
                var induction = inductions.filter((induction) => induction.site === t.selectedSite);
    
                if (induction && induction.length > 0) {

                    var inductionDate2Y = t
						.$moment(induction[0].date, "x")
						.add(2, "years")
						.format("x");
					var currentDate = t.$moment().format("x");
					var inductionDue = t.$moment(currentDate, "x").diff(t.$moment(inductionDate2Y, "x"), "days"); // 1

					switch (true) {
						case inductionDue > 0:
							t.inductionStatus = "expired";
							break;
						case inductionDue > -90 && inductionDue < 0:
							t.inductionStatus = "due";
							break;
                        case inductionDue === '':
                            t.inductionStatus = "required"
						default:
							t.inductionStatus = "valid";
							break;
					}


                } else {
					t.inductionStatus = "notstarted";
                    
                }

				// if (t.GET_currentUser.inductionDate !== '') {
                //     var inductionDate2Y = t
				// 		.$moment(t.GET_currentUser.inductionDate, "x")
				// 		.add(2, "years")
				// 		.format("x");
				// 	var currentDate = t.$moment().format("x");
				// 	var inductionDue = t.$moment(currentDate, "x").diff(t.$moment(inductionDate2Y, "x"), "days"); // 1

				// 	t.inductionRenewal = inductionDate2Y;
				// 	t.inductionDue = inductionDue;

				// 	switch (true) {
				// 		case inductionDue > 0:
				// 			t.inductionStatus = "expired";
				// 			break;
				// 		case inductionDue > -90 && inductionDue < 0:
				// 			t.inductionStatus = "due";
				// 			break;
                //         case inductionDue === '':
                //             t.inductionStatus = "required"
				// 		default:
				// 			t.inductionStatus = "valid";
				// 			break;
				// 	}
				// } else {
				// 	t.inductionStatus = "notstarted";
				// }
			},

            // READ SLIDE FROM DB
            readQuizFromDB() {
                var t = this;
                console.log('selectedSite', t.selectedSite)
                t.$firebase.db.collection("questions").onSnapshot((querySnapshot) => {
                    t.questions = [];
                    querySnapshot.forEach((doc) => {
                        var document = doc.data()
                        document.id = doc.id;
                        console.log('document: ', JSON.stringify(document, null, 2))
                        if (!document.hasOwnProperty('delete')) {
                            if (
                                (!document.site || document.site.length === 0) || 
                                (document.site && document.site.some(site => site.siteId === t.selectedSite))
                            ) {
                                t.questions.push(document);
                            }
                        }
                    });
                    t.randomiseQuestions()
                    t.activeQuestionIndex = 0;
                    t.quizProgress()
                });
            },
            randomiseQuestions() {
                var array = this.questions 
                var n = 10

                var result = new Array(n),
                    len = array.length,
                    taken = new Array(len);
                if (n > len)
                    throw new RangeError("getRandom: more elements taken than available");
                while (n--) {
                    var x = Math.floor(Math.random() * len);
                    result[n] = array[x in taken ? taken[x] : x];
                    taken[x] = --len in taken ? taken[len] : len;
                }
                this.quizQuestions = result;
            },
            // SUBMIT CONFIRMATION
            submitConfirmation: async function(status) {
                var t = this;

                // update users induction for the site
                var induction = {
                    site: t.selectedSite,
                    date: t.$moment().format('x'),
                }

                var inductions = t.GET_currentUser.inductions || [];
                var inductionIndex = inductions.findIndex((induction) => induction.site === t.selectedSite);
                if (inductionIndex > -1) {
                    inductions[inductionIndex] = induction;
                } else {
                    inductions.push(induction);
                }

                var updateInduction = await t.MIX_updateDocumentFieldsById('users', t.GET_currentUser.id, { inductions: inductions });
                if (updateInduction.code === 1) {
                    t.MIX_alert(1, 'Induction Completed', updateInduction.data, null);
                    t.sendInductionNotif(t.GET_currentUser)
                    t.returnToHomePage();
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Induction', null, updateInduction.error);
                }
            },  

            async sendInductionNotif(user) {
                return new Promise((resolve) => {
                    let t = this
                    const url = "https://europe-west2-tfw-swapp.cloudfunctions.net/sendCompletedInductionNotification"
                    t.$axios.post(url, user).then((response) => {
                        resolve({ code: 1, message: 'Induction Details sent to Sponsor', data: response.data, error: null })
                        // t.MIX_alert(1, 'Project Submitted for Review', null, null)
                        t.updateItemStatus('sent');
                    })
                    .catch((error) => {
                        resolve({ code: -1, message: 'Induction Details not send to Sponsor', data: null, error: error.response.data.error.raw.message })
                        // t.MIX_alert(-1, 'Project Not Submitted for Review', null, null)
                    })

                })
            },
            // RETURN TO HOMEPAGE
            returnToHomePage (){
                var t = this;
                setTimeout(function() {
                    t.MIX_go('/');
                },1000 )
            },
            restartQuiz() {
                this.quizProgressPercent=0;
                this.showEndPage = false;
                this.activeQuestionIndex = 0;
                this.quizScore = 0;
                this.readQuizFromDB();
            },

            quizProgress(increment) {
                let t = this
                t.quizProgressPercent = 0
                let index = t.activeQuestionIndex
                if (increment === 'increase') {
                    t.quizProgressPercent = (++index / t.quizQuestions.length) * 100
                } else {
                    t.quizProgressPercent = (--index / t.quizQuestions.length) * 100
                }
            },

            nextQuestion() {
                var t = this;
                t.answerAttempt = 0
                t.correctAnswer = false
                t.activeQuestionIndex++

                document.querySelectorAll('.question-card').forEach((element) => {
                    element.classList.remove('right-answer')
                    element.classList.remove('wrong-answer')
                    element.classList.add('grey')
                })

                t.quizProgress('increase')
                // if (quizno > number) {
                //     t.quizNumber++;
                //     t.showEndPage = true;
                //     return ;
                // } else {
                //     return t.quizNumber++;
                // }

            },

            previousQuestion() {
                var t = this;

                t.answerAttempt = 0
                t.correctAnswer = false
                t.showEndPage = false
                t.activeQuestionIndex--

                document.querySelectorAll('.question-card').forEach((element) => {
                    element.classList.remove('right-answer')
                    element.classList.remove('wrong-answer')
                    element.classList.add('grey')
                })
                // t.quizNumber--
                t.quizProgress('decrease')
                // return 
            },

            checkAnswer(answer, index) {
                let t = this
                if (answer === true) {
                    // t.showQuestionNote = true
                    t.correctAnswer = true
                    t.answerAttempt === 0 ? (t.quizScore = t.quizScore + 1) : null
                    document.querySelectorAll('.question-card')[index].classList.remove('grey')
                    document.querySelectorAll('.question-card')[index].classList.add('right-answer')

                } else if (answer === undefined || answer === '' || answer == false) {
                    t.answerAttempt++
                    document.querySelectorAll('.question-card')[index].classList.remove('grey')
                    document.querySelectorAll('.question-card')[index].classList.add('wrong-answer')
                }
            },

        },
        // * CREATED
        created() {
            var t = this;
            t.selectedSite = t.$route.query.site || '';
            // console.log('selectedSite here', t.selectedSite)
        },
        mounted() {
            var t = this;
            t.updateBreadcrumbs(); // Update Breadcrumbs in Title
			t.currentUsersInduction();
        }
    };
</script>

<style>

.right-answer {
    color: #ffffff !important;
    background-color: green !important;
}

.wrong-answer {
    color: #ffffff !important;
    background-color: red !important;
}

.custom-btn {
  height: auto !important;
  white-space: normal !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.custom-btn ::v-deep .v-btn__content {
  white-space: normal;
  height: auto;
  flex-wrap: wrap;
}

.v-carousel__item {
    height: 700px !important;
    
}

</style>

<style lang="sass">
  @import '~vuetify/src/styles/styles.sass'

  @media #{map-get($display-breakpoints, 'md-and-up')}
    .v-progress-linear 
        width: 100% !important
    

  @media #{map-get($display-breakpoints, 'sm-and-down')}
    .v-progress-linear 
        width: 90vw !important
    

</style>